import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { NOTIFY, PLATFORM } from "../based/Constants";
import DragAndDropIndex from "../based/DragAndDropIndex";
import { SwichToogle } from "../based/inputs/SwitchToogle";
import { Notify } from "../based/Notify";
import Request from "../based/Request";
import PlatformServices from "../based/services/PlatformServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";
import Package1 from "./assets/Package1.jpg";
import Package2 from "./assets/Package2.jpg";
import TiktokLogo from "./assets/TiktokLogo.svg";
import PlatformBrandModal from "./PlatformBrandModal";

function EditShopTiktok(props) {
    const { tokenId } = props.match.params;
    const [model, setModel] = useState({});
    const [showBrandModel, setShowBrandModel] = useState(false);

    useEffect(() => {
        if (+tokenId > 0) {
            getPartnerPlatform(+tokenId);
        }
    }, []);

    const getPartnerPlatform = async (tokenId) => {
        const [err, data] = await PlatformServices.GetPartnerPlatform(tokenId);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
    };

    const createImageShop = async (model) => {
        const [err, data] = await PlatformServices.CreateImageShop(model);
        if (!err && data) {
            getPartnerPlatform(tokenId);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    };

    const swtichAppliedCost = async (tokenId) => {
        const [err, data] = await PlatformServices.SwitchPackageCost(tokenId);
        if (!err && data) {
            setModel({ ...model, isAppliedPackageCost: !model.isAppliedPackageCost });
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    };

    const updateListIndex = async (model) => {
        const [err, data] = await PlatformServices.UpdateIndexDefaultImage(model);
        if (!err && data) {
            getPartnerPlatform(tokenId);
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    };

    const handleChangeImage = async (e) => {
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file) {
            reader.onloadend = () => {
                Request.UploadImage(file)
                    .then((res) => {
                        if (res && res.data) {
                            createImageShop({
                                shopId: model.shopId,
                                platform: model.platform,
                                url: res.data.imageUrl,
                                index: 0,
                            });
                        } else {
                            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Upload failed");
                        }
                    })
                    .catch((err) => {
                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Upload failed");
                    });
            };

            reader.readAsDataURL(file);
        }
    };

    const setIsDefault = async (model) => {
        const [err, data] = await PlatformServices.SetDefaultBrand(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            getPartnerPlatform(tokenId);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    };

    const removePlatformBrand = async (id) => {
        const [err, data] = await PlatformServices.RemovePlatformBrand(id);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Xóa thành công");
            getPartnerPlatform(tokenId);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xóa thất bại");
        }
    };

    if (!model) return <div className="no-data">Hiện không có dữ liệu</div>;
    return (
        <React.Fragment>
            <Breadcum
                options={[
                    {
                        label: "Trang chủ",
                        value: "/",
                    },
                    {
                        label: "Cài đặt kênh bán hàng",
                        value: "/connect-platform-config",
                    },
                    {
                        label: "Cài đặt shop",
                        value: "/edit-shop",
                    },
                ]}
                title={"Cài đặt shop"}
            />
            <Wrapper>
                <section className="shop_logo_brand">
                    <div className="shop_logo_brand-header">
                        <div className="shop_logo_brand-header-logo">{model.platform == PLATFORM.Tiktok && <img src={TiktokLogo} alt="" />}</div>
                        <div className="shop_logo_brand-header-name">{model.shopName}</div>
                    </div>
                    <div className="shop_logo_brand-body">
                        <div className="shop_logo_brand-body-left">
                            <span className="label-group">
                                <h6>Hình ảnh sản phẩm cố định</h6>
                                <span className="count-image">{model.platformUploadDefaultImages && model.platformUploadDefaultImages.length}/5</span>
                            </span>
                            <div className="list-upload-image">
                                {model.platformUploadDefaultImages && (
                                    <DragAndDropIndex
                                        data={model.platformUploadDefaultImages}
                                        renderRow={(item, index) => {
                                            return (
                                                <div className="upload-image" key={index}>
                                                    <img src={item.url} alt="" />
                                                </div>
                                            );
                                        }}
                                        updateIndexFolder={(newLstImage) => {
                                            updateListIndex(newLstImage);
                                        }}
                                    />
                                )}
                                <div
                                    className="upload-image cursor-pointer"
                                    onClick={(e) => {
                                        document.getElementById("upload-image-id").click();
                                    }}
                                >
                                    <div className="icon-upload">
                                        <i className="fa fa-plus"></i>
                                        <span>Thêm hình</span>
                                    </div>
                                </div>
                                <input
                                    id="upload-image-id"
                                    type="file"
                                    className="d-none"
                                    onChange={(e) => {
                                        handleChangeImage(e);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="shop_logo_brand-body-right">
                            <div className="brand-header">
                                <div className="brand-header-left">
                                    <span>
                                        Thương hiệu <i className="fa fa-question-circle-o" />
                                    </span>
                                </div>
                                <div
                                    className="brand-header-right cursor-pointer"
                                    onClick={(e) => {
                                        setShowBrandModel(true);
                                    }}
                                >
                                    <span className="hight-light">
                                        Thêm thương hiệu <i className="fa fa-plus" />
                                    </span>
                                </div>
                            </div>
                            <div className="brand-body">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="center">Thương hiệu</th>
                                            <th className="center">Mặc định</th>
                                            <th className="center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {model.partnerPlatformBrands && model.partnerPlatformBrands.length > 0 ? (
                                            model.partnerPlatformBrands.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td className="vertical-align-middle">{item.brandName}</td>
                                                        <td>
                                                            <input
                                                                type="radio"
                                                                checked={item.isDefault}
                                                                onChange={(e) => {
                                                                    setIsDefault(item);
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="remove-icon cursor-pointer"
                                                                onClick={(e) => {
                                                                    removePlatformBrand(item.id);
                                                                }}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan={50}>
                                                    <div className="no-data">Không có dữ liệu</div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="shop_package">
                    <div className="shop_package-left">
                        <div className="left-header">
                            <h6>Đóng gói hộp</h6>
                            <div className="switch-btn">
                                <SwichToogle
                                    value={model.isAppliedPackageCost}
                                    name="switch"
                                    onCheckChanged={(name, value) => {
                                        swtichAppliedCost(tokenId);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="left-body">
                            <p>
                                Các đơn hàng mặc định được đóng gói hộp Ranus x Partner. Có thể chọn không đóng hộp khi tạo đơn hàng.
                                <br />
                                Chi phí đóng gói hộp khi đẩy sản phẩm là Tạm tính, chi phí chính xác sẽ thể hiện ở chi tiết đơn hàng:
                                <br />
                                <ul>
                                    <li>Đơn hàng từ 1-3 áo sẽ được đóng hộp trung là 13.000đ/hộp</li>
                                    <li>Đơn hàng từ 7 áo trở xuống sẽ được đóng hộp lớn là 20.000đ/hộp</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <div className="shop_package-right">
                        <div className="list-package">
                            <div className="package-item">
                                <img src={Package1} alt="" />
                            </div>
                            <div className="package-item">
                                <img src={Package2} alt="" />
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="simulate_product">
                    <h5>Xem trước hình mô phỏng sản phẩm</h5>
                    <div className="simulate_product-left">
                        <label htmlFor="">Loại mô phỏng</label>
                        <div className="list-psd-thumbnail">
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="psd-thumbnail">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="simulate_product-right">
                        <label htmlFor="">Hình ảnh bìa (Avatar)</label>
                        <div className="list-product-render">
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                            <div className="product-render">
                                <img src="https://cdn.ranus.vn/images/1/ed7f1784-1cc7-4cc2-8c14-859ec47bc7fc-600x600.webp" alt="" />
                            </div>
                        </div>
                    </div>
                </section> */}
            </Wrapper>
            <PlatformBrandModal
                show={showBrandModel}
                onClose={() => setShowBrandModel(false)}
                shopId={model.shopId}
                platform={model.platform}
                onSave={() => {
                    setShowBrandModel(false);
                    getPartnerPlatform(tokenId);
                }}
            />
        </React.Fragment>
    );
}

export default EditShopTiktok;

const Wrapper = styled.div`
    width: 90%;

    .list-upload-image tbody {
        display: flex;
    }

    .upload-image img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .upload-image {
        margin: 6px;
    }

    /* hình mô phỏng sản phẩm */
    section.simulate_product {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px 20px;
        margin: 12px 0;
        display: flex;
        flex-wrap: wrap;
    }

    .simulate_product h5 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        width: 100%;
    }

    .simulate_product-left {
        width: 50%;
    }

    .simulate_product-right {
        flex: 1;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        padding: 24px;
    }

    .simulate_product-left label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .list-psd-thumbnail {
    }

    .list-psd-thumbnail {
        display: flex;
        flex-wrap: wrap;
    }

    .psd-thumbnail {
        width: 73px;
        height: 73px;
        flex-shrink: 0;
        aspect-ratio: 1/1;
        margin: 6px;
    }

    .psd-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .psd-thumbnail.active {
        border-radius: 8px;
        border: 1px solid #ff9027;
        background: linear-gradient(0deg, rgba(255, 144, 39, 0.5) 0%, rgba(255, 144, 39, 0.5) 100%), url(<path-to-image>) lightgray 50% / cover no-repeat;
    }

    .psd-thumbnail.active img {
        opacity: 0.5;
    }

    .simulate_product-right label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .product-render {
        width: 120px;
        height: 120px;
        flex-shrink: 0;
        aspect-ratio: 1/1;
        margin: 12px;
    }

    .product-render img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .list-product-render {
        display: flex;
        flex-wrap: wrap;
    }

    /* đóng gói hộp */
    section.shop_package {
        border-radius: 12px;
        background: #fff;
        margin: 12px 0;
        display: flex;
        padding: 24px 20px;
    }

    .shop_package-left {
        width: 80%;
    }

    .list-package {
        display: flex;
        flex-wrap: wrap;
    }

    .package-item {
        width: 108px;
        height: 108px;
        border-radius: 8px;
        margin: 5px;
    }

    .package-item img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .shop_package-right {
        display: flex;
        align-items: center;
        flex: 1;
    }

    .left-header {
        display: flex;
        align-items: center;
    }

    .switch-btn {
        display: flex;
        margin-left: 24px;
    }

    .left-body {
        margin-top: 24px;
    }

    /* hình ảnh sản phẩm */
    section.shop_logo_brand {
        border-radius: 12px;
        background: #fff;
    }

    .shop_logo_brand-header {
        border: 1px solid #f3f3f3;
        padding: 13px 26px;
        display: flex;
        align-items: center;
    }

    .shop_logo_brand-header-name {
        color: #444;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 24px;
    }

    .shop_logo_brand-body {
        padding: 24px 22px;
        display: flex;
    }

    span.label-group {
        display: flex;
        align-items: center;
    }

    .label-group h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    span.count-image {
        color: #a0a0a0;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 10px;
    }

    .shop_logo_brand-body-left {
        width: 50%;
    }

    .shop_logo_brand-body-right {
        flex: 1;
        margin-left: 24px;
    }

    .list-upload-image {
        display: flex;
        flex-wrap: wrap;
    }

    .upload-image {
        width: 85px;
        height: 85px;
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .icon-upload {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .icon-upload span {
        color: #303030;
        text-align: center;
        font-family: Lexend;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 4px;
    }

    .brand-header {
        display: flex;
        align-items: center;
        margin-bottom: 14px;
    }

    .brand-header-right {
        margin-left: auto;
    }

    .brand-header-left span {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    span.hight-light {
        color: #ff9027;
        text-align: center;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .table thead {
        background: #f3f3f3;
    }
`;
